module.exports = __webpack_public_path__ + "static/img/ios1.1c2d14b7.webp";